import { Icon } from "@mindlercare/ui-web";
import { format } from "date-fns";
import { styled } from "styled-components";
import { Typography } from "components/typography";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";

interface Props {
  date: Date | false;
  responseIsNewerThanFeedback: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const DateText = ({ date }: { date?: Date | false }) => {
  if (!date) {
    return (
      <Typography insensitive variant="body">
        {"--"}
      </Typography>
    );
  }
  return (
    <Typography variant="body" color="GRAY_BLACK">
      {format(date, "MMM dd")}
    </Typography>
  );
};

export const ResponseDateText = ({
  date,
  responseIsNewerThanFeedback,
}: Props) => {
  return (
    <Wrapper>
      {date ? (
        <MessageIcon
          width={defaultTheme.ICON_SIZE.STANDARD}
          $unread={responseIsNewerThanFeedback}
        />
      ) : null}
      <DateText date={date} />
    </Wrapper>
  );
};

const MessageIcon = styled(Icon.FeedbackCheckmark)<{ $unread: boolean }>`
  color: ${({ theme, $unread }) =>
    $unread ? theme.COLORS.ERROR : theme.COLORS.SUCCESS};
`;
